<div class="error-class">
    <h1 mat-dialog-title class="text-center"> <i class="fas fa-exclamation-triangle me-2"></i>{{data.error.title}}</h1>
    <div mat-dialog-content>{{data.error.error}}</div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close >Close</button>
    </div>
</div>